import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err.config;
    if (err.response?.status === 401 && !orig._retry && !orig.url.includes("/auth/")) {
      orig._retry = true;
      try {
        await axios.post(`${API}/auth/refresh`, {}, { withCredentials: true });
        return api(orig);
      } catch (e) {
        /* sessione scaduta */
      }
    }
    return Promise.reject(err);
  }
);

export const imgUrl = (p) => (p && p.startsWith("/") ? `${BACKEND_URL}${p}` : p);

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return "Si è verificato un errore. Riprova.";
}
